import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faCircleCheck as fasCircleCheck, faPlay as fasPlay } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import type { ReactNode } from "react";
import { Button, Card } from "react-bootstrap";

export class JtmKoPage extends AbstractStep {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header className="bg-soft text-center">
					<p className="font-weight-bold display-6">
						A megadott hitelösszeg, futamidő és jövedelem kombinációra nem találtunk megfelelő ajánlatot.
					</p>
				</Card.Header>
				<Card.Body>
					<div className="align-items-center d-flex my-3">
						<FontAwesomeIcon icon={fasCircleCheck} size="5x" className="mr-2 text-success" />
						<span className="font-weight-bold text-left">De ne aggódj, megtaláljuk a hiteled!</span>
					</div>
					<hr />
					<p className="text-center mt-5">
						Tudd meg néhány kattintással, hogy mennyi lakáshitelt kaphatsz. Kisebb hitelösszegre, hosszabb
						futamidőre vagy extra bevont jövedelem mellett megtalálod a megfelelő hitelt a kiszemelt
						ingatlan megvásárlására.
					</p>
				</Card.Body>
				<Card.Footer className="bg-soft">
					<p className="font-weight-bold">
						Nézd meg a Bankmonitor kalkulátorával, hogy milyen piaci kölcsönök érhetők el számodra.
					</p>
					<Button
						block
						className="font-weight-bold"
						href="/lakashitel-kalkulator/mennyi-lakashitelt-kaphatok"
						onClick={() => this.sendEvent("BM_openCalculator")}
					>
						<FontAwesomeIcon icon={fasPlay} className="mr-2" />
						Kalkulátor megnyitása
					</Button>
				</Card.Footer>
			</>
		);
	}
	protected getComponentName(): string {
		return "JtmKoPage";
	}
}
